export default __webpack_public_path__ + "static/media/line-v-04.ea3e4814.png";